<template>
	<div v-show="bodyIsShow">
		<div id="brandwrap" class="bodywrap"> 
		    <!--头部 start--> 
		    <header> 
		      <a class="fl searchHeader-back" href="javascript:window.history.go(-1);"></a>
		      <span class="title">选择品牌</span>
		    </header>
		    <!--头部 end-->
		    <div id="brandLetter-wrap" v-for="(item,index) in brandLetterList">
			    <div class="brandLetter">
			       {{index}}     
			    </div>
			      <ul id="brandLetterUl" class="brandLetterUl">
			      	<li class="clearfix" :rel="itemChild.id" v-for="(itemChild,index) in item" @click="getCarStyle(itemChild.id)">
			          <div class="clearfix carBrandList-img">
			           <img class="scrollLoading" :src="itemChild.logo" />
			          </div>
			          <div class="clearfix carBrandList-title">
			           <span class="clearfix carBrandList-title-l">{{itemChild.name}}</span>
			          </div>    
			        </li>
			      </ul>
		    </div>
		    <div id="carStyle-mark1" class="carStyle-mark"></div>
		    <div id="carStyle-wrap1" class="carStyle-wrap">
		    	<dl v-for="(itemAll,indexAll) in carStyleList" class="carStyle-dl" >
		    		<dt class="clearfix">
		    			<a class="clearfix" :href="'/'+ cityPy +'/b'+itemAll.brandId+'/tuan/'">
		    				<span class="fl carStyle-name">
		    					<img :src="itemAll.brandPic" />
		    					{{itemAll.brandName}}
		    				</span>
		    				<span class="fr carStyle-baoming">
		    					品牌报名
		    					<em></em>
		    				</span>
		    			</a>
		    		</dt>
		    		<dd>
		    			<ul v-if="priceType" class="carStyle-ul">
		    				<li class="clearfix" v-for="(item,index) in itemAll.styleList">
		    					 <a :href="'/mapply/GroupBuy/pricePage?id='+item.id+'&cityId='+ cityId +'&styleName=' +item.styleName+'&brandId='+itemAll.brandId">
			    					<div class="fl carStyle-ul-img">
			    						<img :src="item.logo" />
			    					</div>
			    					<div class="fl carStyle-ul-info">
			    						<p class="carStyle-ul-info-name">{{item.styleName}}</p>
			    						<p class="carStyle-ul-info-price">{{item.factoryPrice}}</p>
			    					</div>
		    					</a>
		    				</li>
		    			</ul>
		    			<ul v-else class="carStyle-ul">
		    				<li class="clearfix" v-for="(item,index) in itemAll.styleList">
		    					<a :href="'/'+ cityPy +'/c'+item.id+'/tuan/'">
			    					<div class="fl carStyle-ul-img">
			    						<img :src="item.logo" />
			    					</div>
			    					<div class="fl carStyle-ul-info">
			    						<p class="carStyle-ul-info-name">{{item.styleName}}</p>
			    						<p class="carStyle-ul-info-price">{{item.factoryPrice}}</p>
			    					</div>
		    					</a>
		    				</li>
		    			
		    			</ul>
		    		</dd>
		    	</dl>
		    </div>  
		    <div class="ziMuBody">
		      <ul class="ziMuUl">
			      <li v-for="(item,index) in brandLetterList" class="zimu">{{index}}</li>
		      </ul>
		    </div>
		  </div>
	</div>
</template>

<script>
	export default{
		name: 'brandStyle',
		data:function(){
			return{
				bodyIsShow:false,
				cityPy:this.$route.params.cityPy,
				brandLetterList:[],
				brandId:null,
				brandIdSec:null,
				carStyleList:{
					brandId:'',
					brandName:'',
					brandPic:'',
					styleList:[]
				},
				priceType:'',
				brandValid:"",
				cityId:''
			}
		},
		beforeCreate:function(){
			getCommonJsIns.initCSSwap02({
				cssURL:"/css/commons/common.css"
			});
			getCommonJsIns.initCSSwap02({
				cssURL:"/css/default/brandstyle.css"
			});
		},
		mounted:function(){
			var self = this;
			document.title="选择品牌";
			getCommonJsIns.initDefaultJS(self.webReady);
			if(self.$route.query.type) {//获取ur里面type用于区分跳转
				self.priceType = self.$route.query.type
			}
			// console.log(self.priceType);
			self.cityId=self.$route.query.cityId; 
			// console.log(self.cityId);
		},
		methods:{
			webReady:function(){
				var self = this;
				this.bodyIsShow = true;
				this.ajaxSubmit.ajax({
					url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcBrand+"?cityId="+self.$route.query.cityId,
					//url:"http://oo.tuanche.com:8083/data/data.js"
					type:"get",
					dataType:"json",
					success:function(data){
						var result = data.response.result;
						if(data.responseHeader.status == 200){
							self.brandLetterList=result;
//							self.brandValid=$('#branIdVal').val();
							// console.log(self.brandValid);
							setTimeout(function(){ webCommonUtil.getBrandCarStyle.fixedLetter($(".brandLetter"),$(window))},100);
						}
					},
					error:function(){
	
					}
				});
				
				//getCommonJsIns.loadJs(this.commmonWebConfig.staticWap01 + "/script/default/brandphp.js",function(){});
				//getCommonJsIns.loadJs(this.commmonWebConfig.staticWap01 + "/script/commons/sid.js",function(){});
				//getCommonJsIns.loadJs(this.commmonWebConfig.staticWap01 + "/script/lib/require.js",function(){});
			},
			getCarStyle:function(brandId){
				var self = this;
				self.brandId = brandId;
				$("#carStyle-mark1").height($(document).height());
			    $("#carStyle-wrap1,#carStyle-mark1").show("fast",function(){
			    $("body").css("position","fixed");     
			    $("#carStyle-mark1").click(function(){
			    $("#carStyle-wrap1,#carStyle-mark1").hide("fast",function(){
			        $("body").css("position","static");
			      });
				});
  
			    });
				this.ajaxSubmit.ajax({
					url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.baseDataTcStyle+"?brandId="+brandId+"&cityId="+self.$route.query.cityId,
					//url:"http://oo.tuanche.com:8083/data/data.js"
					type:"get",
					dataType:"json",
					success:function(data){
						var result = data.response.result;
						if(data.responseHeader.status == 200){
							self.carStyleList=result;
							
						}
					},
					error:function(){
	
					}
				});
			}
		}

	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/default/brandStyle.vue